// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"e302efa5","498":"ca869461","703":"8dc19e5b"}[chunkId] + ".chunk.js";
};